
    <div id="{{'LoadChart_ReportedMA_' + this.PlayerId}}" style="height: 400px;">

    </div>

